export class ShotResume {
	requiredShots: number = 0;
	approvedShots: number = 0;
	rejectedShots: number = 0;
	uploadedShots: number = 0;
	missingShots: number = 0;

	constructor(init?: Partial<ShotResume>) {
		Object.assign(this, init);
	}
}
